export var CONDITION_TAG_CLASS_PREFIX = 'ConditionTag';